export const highlight = (value: React.ReactNode) => (
	<span style={{ color: "#FBBD05" }}>{value}</span>
);

export const formatDuration = (minutes?: number) => {
	if (typeof minutes !== "number" || minutes <= 0) {
		return "";
	}
	if (minutes < 60) {
		return `${minutes} ${minutes === 1 ? "min" : "mins"}`;
	}
	if (minutes % 60 === 0) {
		const hours = minutes / 60;
		return `${hours} ${hours === 1 ? "hr" : "hrs"}`;
	}
	const hours = Math.floor(minutes / 60);
	const remaining = minutes % 60;
	const hoursPart = `${hours}h`;
	const minsPart = `${remaining}m`;
	return `${hoursPart} ${minsPart}`;
};
